import { useEffect, useState } from 'react'

import { getIdentity } from '../useParticipants/useParticipants'
import useVideoContext from '../useVideoContext/useVideoContext'

export default function useTrack(publication, participant = null) {
    const { setRemoteDataPub } = useVideoContext()
    const [track, setTrack] = useState(publication && publication.track)

    useEffect(() => {
        // Reset the track when the 'publication' variable changes.

        if (publication) {
            setTrack(publication.track)

            const removeTrack = () => setTrack(null)

            if (
                publication.isSubscribed &&
                publication.track.kind === 'data' &&
                participant &&
                getIdentity(participant.identity).isTeacher
            ) {
                setRemoteDataPub(publication.track)
            }

            const handleSubscribeFn = dataTrack => {
                if (dataTrack.kind === 'data') {
                    if (
                        participant &&
                        getIdentity(participant.identity).isTeacher
                    )
                        setRemoteDataPub(dataTrack)
                } else setTrack(publication && publication.track)
            }

            publication.on('subscribed', handleSubscribeFn)
            publication.on('unsubscribed', removeTrack)

            return () => {
                publication.off('subscribed', handleSubscribeFn)
                publication.off('unsubscribed', removeTrack)
            }
        }
    }, [publication])

    return track
}
